export const getQryValue = (path) => {
  if (!path || !window.location.search) return "";
  const qry = new URLSearchParams(window.location.search);
  return qry.get(path) || "";
};
